import axios from 'axios';
import { onDomChanges } from '../../components/dynamic/observer';
import { singleBind } from '../../components/dynamic/bind';
import { notifyResponse } from '../notifications/notify';

async function compilationToggle(linkElement) {
  let inCompilation = Boolean(linkElement.dataset.active);

  const currentUrl = linkElement.getAttribute('href');
  const response = await axios.post(currentUrl);

  if (notifyResponse(response) && response.data.success) {
    inCompilation = !inCompilation;
    const addUrl = linkElement.dataset.add;
    const removeUrl = linkElement.dataset.remove;

    // Переключаем вкл/выкл
    linkElement.dataset.active = inCompilation ? '1' : '';
    linkElement.setAttribute('href', inCompilation ? removeUrl : addUrl);

    const event = new CustomEvent('compilationToggle', {
      detail: {
        linkElement,
        inCompilation,
      },
    });
    document.dispatchEvent(event);
  }
}

function initCompilation() {
  document.querySelectorAll('[data-compilation-toggle]').forEach((link) => {
    singleBind(link, 'bind', 'click', (e) => {
      e.preventDefault();
      compilationToggle(link);
    });
  });
}

onDomChanges(initCompilation);
initCompilation();